import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import UserRoleModal from './UserRole_Modal';
import { deleteUserRole, getUserRoleList,copyUserRole} from '../actions/UserRoleActions';
import Alert from 'react-s-alert';
import PaginatorCustom from '../../../../../components/paginationCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import SortingCustom from '../../../../../components/SortingCustom';
import { alertConfirmation, resetFiltersAndSorting } from '../../../../../actions/utilAction';
import history from '../../../../../../src/history';

class UserRoleList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      userRoleId: null,
    };
    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };

    this.handleSearchUserRole = this.handleSearchUserRole.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number || 1,
    };
    this.props.getUserRoleList(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_userRole && nextProps.saved_userRole !== this.props.saved_userRole) {
      this.loadData();
    }
    if (nextProps.deleted_userRole && nextProps.deleted_userRole !== this.props.deleted_userRole) {
      this.loadData();
    }
    if (nextProps.copied_userRole && nextProps.copied_userRole !== this.props.copied_userRole) {
      this.loadData();
    }
  }

  handleReset = () => {
    Alert.closeAll();
    this.props.dispatch(reset('UserRoleListForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadData();
  };
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, userRoleId: null });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleAlertClick = (event, RoleID) => {
    this.props.deleteUserRole(RoleID);
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {
    alertConfirmation('Are you sure you want to delete User Role details?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleCopyAlertClick = (event, RoleID)=>{
    Alert.closeAll()
    this.props.copyUserRole(RoleID)
  }  
  handleCopyUserRoleClick = (event, obj) => {
      alertConfirmation('Would you like to copy this item? You can edit it later.', {
        customFields: {
          displayComponent: true,
          handleButtonClick: this.handleCopyAlertClick,
          id: obj.id,
        },
      });
    }
  

  handleEditClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ open: true, userRoleId: obj.id });
  }
  componentWillUnmount() {
    Alert.closeAll();
  }

  handleAssignPermissionClick = (event, obj) => {
    history.push('/role-permissions/' + obj.id);
  }

  handleSearchUserRole() {
    return false;
  }


  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }


  renderData(userRolesList) {
    userRolesList = userRolesList || [];
    if (!userRolesList.length) {
      return (
        <tr>
          <td colSpan="3">
            <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }

    return userRolesList.map((Obj, index) => {
      let isRoleNotAdminOrClient = ((Obj.userType || '').toUpperCase() !== 'ADMIN' && (Obj.userType || '').toUpperCase() !== 'CLIENT') ? true : false;
      return (
        <tr key={index}>
          <td>{Obj.roleName}</td>
          <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Active' : 'Inactive'}</td>
          {/* {<td>{data.Description != null && data.Description.length > 75 ? SubString(data.Description, 75, data.Description.length) + '...' : data.Description != null ? data.Description : 'N/A'}</td>} */}
          {isRoleNotAdminOrClient && (this.props.updatePermission || this.props.deletePermission || this.props.assignPermission)
            ?
            <td>

              {this.props.updatePermission ?
                <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                : null
              }
              {this.props.assignPermission ?
                <button onClick={(e) => this.handleAssignPermissionClick(e, Obj)} type="button" title="Assign Permissions" className="tbactionbtn yellowfont"><i className="fa fa-external-link" aria-hidden="true"></i></button>
                : null
              }
               <button type="button" onClick={(e) =>this.handleCopyUserRoleClick(e,Obj)} title="Clone" className="tbactionbtn bluefont"><i className="fa fa-clone" aria-hidden="true"></i></button>
              {this.props.deletePermission ?
                <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                : null
              }
            </td>
            : <td></td>
          }
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit, userRolesData } = this.props;
    let userRolesList = (userRolesData && userRolesData.data) || [];
    let userRolesMeta = (userRolesData && userRolesData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        <h2 className="page_title">Manage User Role</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {this.props.addPermission && <RaisedButton label="Add Role" primary={true} onTouchTap={this.handleOpen} />}
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchUserRole)}>
                        <Field
                          name="roleName"
                          floatingLabelText="Search"
                          maxLength='15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.open && <UserRoleModal userRoleId={this.state.userRoleId} closeDialog={this.handleClose} />}
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="40%"><SortingCustom noSort={!userRolesList.length} setSortColumn={this.setSortColumn} columnName='roleName' displayName='Role' /></th>
                        <th width="40%"><SortingCustom noSort={!userRolesList.length} setSortColumn={this.setSortColumn} columnName='IsActive' displayName='Status' /></th>
                        {this.props.updatePermission || this.props.deletePermission || this.props.assignPermission
                          ?
                          <th width="20%">Action</th>
                          : null
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderData(userRolesList)}
                    </tbody>
                  </table>

                  {userRolesMeta && userRolesMeta['totalPages'] ?
                    <PaginatorCustom data={userRolesMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserRoleList = reduxForm({
  form: 'UserRoleListForm',
})(UserRoleList);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_USERROLES_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_USERROLES_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_USERROLES_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_USERROLES_LIST_DELETE')[0].permission : false;
  let assignPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_USERROLES_LIST_ASSIGN_PERMISSIONS')[0].permission : false;

  // End For Role Permission

  return {
    loading: state.userRoles.loading,
    userRolesData: state.userRoles.userRolesList,
    saved_userRole: state.userRoles.saved_userRole,
    deleted_userRole: state.userRoles.deleted_userRole,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
    copied_userRole: state.userRoles.copied_UserRole,
    assignPermission: assignPermission,
  };
}
export default connect(mapStateToProps, { getUserRoleList, deleteUserRole,copyUserRole})(UserRoleList);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/userRoles/components/index.js